import * as React from "react"

function SvgVipRoyal(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 50 50"
      {...props}
    >
      <g
        stroke="#E1A323"
        strokeWidth={2.083}
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M25 1.042c13.231 0 23.958 10.727 23.958 23.958 0 13.231-10.727 23.958-23.958 23.958C11.769 48.958 1.042 38.231 1.042 25 1.042 11.769 11.769 1.042 25 1.042z" />
        <path d="M11.458 31.25c0 1.15.934 2.083 2.084 2.083H37.5c1.15 0 2.083-.933 2.083-2.083V20a1.04 1.04 0 00-1.727-.783L31.25 25l-5.458-6.369a1.041 1.041 0 00-1.584 0L18.75 25l-5.512-5.512a1.04 1.04 0 00-1.78.735V31.25z" />
      </g>
    </svg>
  )
}

export default SvgVipRoyal
